import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useMediaQuery } from "./use-media-query";
/**
 * React hook used to get the user's animation preference.
 */

export function usePrefersReducedMotion() {
  var _useMediaQuery = useMediaQuery("(prefers-reduced-motion: reduce)"),
      _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
      prefersReducedMotion = _useMediaQuery2[0];

  return prefersReducedMotion;
}
/**
 * React hook for getting the user's color mode preference.
 */

export function useColorModePreference() {
  var _useMediaQuery3 = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"]),
      _useMediaQuery4 = _slicedToArray(_useMediaQuery3, 2),
      isDark = _useMediaQuery4[0],
      isLight = _useMediaQuery4[1];

  if (isLight) return "light";
  if (isDark) return "dark";
  return undefined;
}